export class Config {

  readonly DIRECTBANKING_MIDDLEWARE_API_URL?: string;
  readonly JWT_KEY_ENDPOINT?: string;
  readonly OAUTH_LOGIN?: string;
  readonly OAUTH_LOGOUT?: string;
  constructor() {
    this.DIRECTBANKING_MIDDLEWARE_API_URL = process.env.DIRECTBANKING_MIDDLEWARE_API_URL ? process.env.DIRECTBANKING_MIDDLEWARE_API_URL : '';
    this.JWT_KEY_ENDPOINT = process.env.JWT_KEY_ENDPOINT ? process.env.JWT_KEY_ENDPOINT : '';
    this.OAUTH_LOGIN = process.env.OAUTH_LOGIN ? process.env.OAUTH_LOGIN : '';
    this.OAUTH_LOGOUT = process.env.OAUTH_LOGOUT ? process.env.OAUTH_LOGOUT : '';
  }
}